import {
  CreditcardPaymentProviderViewConfig,
} from '@/services/payment/creditcard-payment-provider/creditcard-payment-provider-service'
import {
  AuthDiv,
  KuronekoServiceForPurchase,
  KuronekoServiceForSubscription,
} from '@/services/payment/creditcard-payment-provider/provider/kuroneko'
import { KuronekoServiceAuthConfig } from '@/services/payment/creditcard-payment-provider/provider/kuroneko/config'

export function getKuronekoServiceBuilder() {
  const builder = KuronekoServiceBuilder.start()

  return builder.withSecurityCode('onRegisterCard')
}

class KuronekoServiceBuilder {
  public static start(): KuronekoServiceBuilder {
    return new this(
      {
        onPayment: AuthDiv.NotUseSecure,
        onRegisterCard: AuthDiv.NotUseSecure,
      }
    )
  }

  private constructor(
    private authDiv: KuronekoServiceAuthConfig
  ) {
  }

  withSecurityCode(at: keyof KuronekoServiceAuthConfig): this {
    this.authDiv[at] = AuthDiv.UseSecurityCode

    return this
  }

  forPurchase(): KuronekoServiceForPurchase {
    return new KuronekoServiceForPurchase({
      onPayment: AuthDiv.NotUseSecure,
      onRegisterCard: AuthDiv.UseSecurityCode,
    })
  }

  forSubscription(): KuronekoServiceForSubscription {
    return new KuronekoServiceForSubscription({
      onPayment: AuthDiv.NotUseSecure,
      onRegisterCard: AuthDiv.Use3DSecureAndSecurityCode,
    })
  }

  viewConfig(): CreditcardPaymentProviderViewConfig {
    return {
      registerCardForm: {
        requireCardOwner: true,
        requireSecurityCode: this.requireSecurityCode(this.authDiv.onRegisterCard),
      },
      paymentForm: {
        requireSecurityCode: this.requireSecurityCode(this.authDiv.onPayment),
      },
    }
  }

  private requireSecurityCode(authDiv: AuthDiv): boolean {
    return [
      AuthDiv.UseSecurityCode,
      AuthDiv.Use3DSecureAndSecurityCode,
    ].some(c => c === authDiv)
  }
}
